import React, { useContext } from 'react';
import './OrdersDetails.css'
import OrdersOptions from './OrdersOptions'
import { GetUserContext } from '../../Context/GetUserContext';

const OrdersDetails = () => {
    const subTitleOrders = ["Pedidos Pendentes", "Em Processamento", "Pedidos Faturados", "Pedidos em Devolução", "Pedidos Cancelados"]

    return (<OrdersOptions subTitleOrders={subTitleOrders} />)
}

export default OrdersDetails